import styled from 'styled-components';

import { sizes } from '../../theme/sizes';

interface Props {
  mtSize?: 'none' | 'sm' | 'md' | 'lg' | 'auto' | 'initial';
  mlSize?: 'none' | 'sm' | 'md' | 'lg' | 'auto' | 'initial';
}

export const ButtonsContainer = styled.div<Props>`
  margin-top: ${({ mtSize }) => sizes[mtSize || 'initial']};
  margin-left: ${({ mlSize }) => sizes[mlSize || 'initial']};

  display: flex;

  button {
    flex: 1;
    display: flex;
    align-items: center;
    margin-top: 0;
    justify-content: center;
  }

  & > * + * {
    margin-left: 0.5em;
  }
`;
